export default __webpack_public_path__ + "static/media/emma.25a24a97.jpeg";